import { render, staticRenderFns } from "./Factory-editor.vue?vue&type=template&id=1396d5ce&scoped=true&"
import script from "./Factory-editor.vue?vue&type=script&lang=js&"
export * from "./Factory-editor.vue?vue&type=script&lang=js&"
import style0 from "./Factory-editor.vue?vue&type=style&index=0&id=1396d5ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1396d5ce",
  null
  
)

export default component.exports